export default __webpack_public_path__ + "static/media/Flag_of_Finland.e6682c3f.svg";